//
// # Built-In Schematic Symbols (GENERATED)
//
// DO NOT EDIT THIS FILE BY HAND.
//
// Generated from the canonical JSON in the repo-root /schematic-builtins/
// directory by `yarn gen-builtins` (Editor/scripts/gen-builtins.ts).
// To change a builtin symbol, edit its JSON and re-run `yarn gen-builtins`.
//

import { SCHEMA_VERSION } from "GenAlphaSchema";
import { BuiltinSpec } from "./share";

export const Nmos = {
  defaultNamePrefix: "m",
  id: "nmos",
  symbol: {
    bbox: {
      max: {
        x: 128,
        y: 44,
      },
      min: {
        x: -68,
        y: -89,
      },
    },
    contentKind: "symbol",
    exprLabels: [
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-name",
        loc: {
          x: 50,
          y: 35,
        },
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 45,
          y: 20,
        },
        rotation: 0,
        spec: {
          index: 1,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 45,
          y: -55,
        },
        rotation: 0,
        spec: {
          index: 5,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 45,
          y: -25,
        },
        rotation: 0,
        spec: {
          index: 3,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 45,
          y: -40,
        },
        rotation: 0,
        spec: {
          index: 4,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 45,
          y: 5,
        },
        rotation: 0,
        spec: {
          index: 2,
          kind: "index",
        },
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: 15,
          y: 6,
        },
        name: "g",
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "middle",
        height: 8,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: 45,
          y: -4,
        },
        name: "b",
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: 35,
          y: -29,
        },
        name: "s",
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: 35,
          y: 20,
        },
        name: "d",
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "cell-name",
        loc: {
          x: 30,
          y: 35,
        },
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 45,
          y: -70,
        },
        rotation: 0,
        spec: {
          index: 6,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 45,
          y: -85,
        },
        rotation: 0,
        spec: {
          index: 7,
          kind: "index",
        },
      },
    ],
    graphics: [
      {
        bbox: {
          max: {
            x: 25,
            y: 15,
          },
          min: {
            x: 20,
            y: -15,
          },
        },
        filled: true,
        kind: "rectangle",
      },
      {
        kind: "path",
        points: [
          {
            x: 15,
            y: 15,
          },
          {
            x: 15,
            y: -15,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 20,
            y: -15,
          },
          {
            x: 40,
            y: -15,
          },
          {
            x: 40,
            y: -30,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 20,
            y: 15,
          },
          {
            x: 40,
            y: 15,
          },
          {
            x: 40,
            y: 30,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: 0,
          },
          {
            x: 15,
            y: 0,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 30,
            y: -20,
          },
          {
            x: 40,
            y: -15,
          },
          {
            x: 30,
            y: -10,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 20,
            y: 0,
          },
          {
            x: 40,
            y: 0,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 20,
            y: -15,
          },
          {
            x: 20,
            y: 15,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
    ],
    ident: {
      id: "nmos",
      kind: "builtin",
    },
    pins: [
      {
        direction: "inout",
        portName: "b",
        shape: {
          bbox: {
            max: {
              x: 44,
              y: 4,
            },
            min: {
              x: 36,
              y: -4,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
      {
        direction: "inout",
        portName: "s",
        shape: {
          bbox: {
            max: {
              x: 44,
              y: -26,
            },
            min: {
              x: 36,
              y: -34,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
      {
        direction: "inout",
        portName: "g",
        shape: {
          bbox: {
            max: {
              x: 4,
              y: 4,
            },
            min: {
              x: -4,
              y: -4,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
      {
        direction: "inout",
        portName: "d",
        shape: {
          bbox: {
            max: {
              x: 44,
              y: 34,
            },
            min: {
              x: 36,
              y: 26,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
    ],
    schemaVersion: SCHEMA_VERSION,
    selectionBoxes: [
      {
        max: {
          x: 40,
          y: 30,
        },
        min: {
          x: 0,
          y: -30,
        },
      },
    ],
  },
} satisfies BuiltinSpec<"nmos">;
export type Nmos = typeof Nmos;

export const Pmos = {
  defaultNamePrefix: "m",
  id: "pmos",
  symbol: {
    bbox: {
      max: {
        x: 128,
        y: 44,
      },
      min: {
        x: -68,
        y: -89,
      },
    },
    contentKind: "symbol",
    exprLabels: [
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-name",
        loc: {
          x: 50,
          y: 35,
        },
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 45,
          y: 20,
        },
        rotation: 0,
        spec: {
          index: 1,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 45,
          y: -55,
        },
        rotation: 0,
        spec: {
          index: 5,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 45,
          y: -25,
        },
        rotation: 0,
        spec: {
          index: 3,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 45,
          y: -40,
        },
        rotation: 0,
        spec: {
          index: 4,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 45,
          y: 5,
        },
        rotation: 0,
        spec: {
          index: 2,
          kind: "index",
        },
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: 15,
          y: 6,
        },
        name: "g",
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "middle",
        height: 8,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: 45,
          y: -4,
        },
        name: "b",
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: 35,
          y: 20,
        },
        name: "s",
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: 35,
          y: -29,
        },
        name: "d",
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "cell-name",
        loc: {
          x: 30,
          y: 35,
        },
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 45,
          y: -70,
        },
        rotation: 0,
        spec: {
          index: 6,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 45,
          y: -85,
        },
        rotation: 0,
        spec: {
          index: 7,
          kind: "index",
        },
      },
    ],
    graphics: [
      {
        bbox: {
          max: {
            x: 25,
            y: 15,
          },
          min: {
            x: 20,
            y: -15,
          },
        },
        filled: true,
        kind: "rectangle",
      },
      {
        bbox: {
          max: {
            x: 15,
            y: 5,
          },
          min: {
            x: 5,
            y: -5,
          },
        },
        filled: false,
        kind: "ellipse",
      },
      {
        kind: "path",
        points: [
          {
            x: 15,
            y: 15,
          },
          {
            x: 15,
            y: -15,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 20,
            y: -15,
          },
          {
            x: 40,
            y: -15,
          },
          {
            x: 40,
            y: -30,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 20,
            y: 15,
          },
          {
            x: 40,
            y: 15,
          },
          {
            x: 40,
            y: 30,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: 0,
          },
          {
            x: 5,
            y: 0,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 40,
            y: 20,
          },
          {
            x: 30,
            y: 15,
          },
          {
            x: 40,
            y: 10,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 20,
            y: 0,
          },
          {
            x: 40,
            y: 0,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 20,
            y: -15,
          },
          {
            x: 20,
            y: 15,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
    ],
    ident: {
      id: "pmos",
      kind: "builtin",
    },
    pins: [
      {
        direction: "inout",
        portName: "g",
        shape: {
          bbox: {
            max: {
              x: 4,
              y: 4,
            },
            min: {
              x: -4,
              y: -4,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
      {
        direction: "inout",
        portName: "d",
        shape: {
          bbox: {
            max: {
              x: 44,
              y: -26,
            },
            min: {
              x: 36,
              y: -34,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
      {
        direction: "inout",
        portName: "b",
        shape: {
          bbox: {
            max: {
              x: 44,
              y: 4,
            },
            min: {
              x: 36,
              y: -4,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
      {
        direction: "inout",
        portName: "s",
        shape: {
          bbox: {
            max: {
              x: 44,
              y: 34,
            },
            min: {
              x: 36,
              y: 26,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
    ],
    schemaVersion: SCHEMA_VERSION,
    selectionBoxes: [
      {
        max: {
          x: 40,
          y: 30,
        },
        min: {
          x: 0,
          y: -30,
        },
      },
    ],
  },
} satisfies BuiltinSpec<"pmos">;
export type Pmos = typeof Pmos;

export const Npn = {
  defaultNamePrefix: "q",
  id: "npn",
  symbol: {
    bbox: {
      max: {
        x: 100,
        y: 50,
      },
      min: {
        x: -10,
        y: -50,
      },
    },
    contentKind: "symbol",
    exprLabels: [
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-name",
        loc: {
          x: 50,
          y: -40,
        },
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 50,
          y: -28,
        },
        rotation: 0,
        spec: {
          index: 1,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 50,
          y: -16,
        },
        rotation: 0,
        spec: {
          index: 2,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 50,
          y: -4,
        },
        rotation: 0,
        spec: {
          index: 3,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 50,
          y: 8,
        },
        rotation: 0,
        spec: {
          index: 4,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 50,
          y: 20,
        },
        rotation: 0,
        spec: {
          index: 5,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 50,
          y: 32,
        },
        rotation: 0,
        spec: {
          index: 6,
          kind: "index",
        },
      },
      {
        alignment: "right",
        baseline: "middle",
        height: 8,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -2,
          y: 0,
        },
        name: "b",
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: 35,
          y: -40,
        },
        name: "e",
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "top",
        height: 8,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: 35,
          y: 40,
        },
        name: "c",
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "cell-name",
        loc: {
          x: 45,
          y: -45,
        },
        rotation: 0,
      },
    ],
    graphics: [
      {
        kind: "path",
        points: [
          {
            x: 20,
            y: -15,
          },
          {
            x: 20,
            y: 15,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 3,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: 0,
          },
          {
            x: 20,
            y: 0,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 20,
            y: -8,
          },
          {
            x: 40,
            y: -25,
          },
          {
            x: 40,
            y: -40,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 20,
            y: 8,
          },
          {
            x: 40,
            y: 25,
          },
          {
            x: 40,
            y: 40,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 30,
            y: -10,
          },
          {
            x: 33,
            y: -19,
          },
          {
            x: 24,
            y: -18,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
    ],
    ident: {
      id: "npn",
      kind: "builtin",
    },
    pins: [
      {
        direction: "inout",
        portName: "e",
        shape: {
          bbox: {
            max: {
              x: 44,
              y: -36,
            },
            min: {
              x: 36,
              y: -44,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
      {
        direction: "inout",
        portName: "b",
        shape: {
          bbox: {
            max: {
              x: 4,
              y: 4,
            },
            min: {
              x: -4,
              y: -4,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
      {
        direction: "inout",
        portName: "c",
        shape: {
          bbox: {
            max: {
              x: 44,
              y: 44,
            },
            min: {
              x: 36,
              y: 36,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
    ],
    schemaVersion: SCHEMA_VERSION,
    selectionBoxes: [
      {
        max: {
          x: 45,
          y: 40,
        },
        min: {
          x: 0,
          y: -40,
        },
      },
    ],
  },
} satisfies BuiltinSpec<"npn">;
export type Npn = typeof Npn;

export const Pnp = {
  defaultNamePrefix: "q",
  id: "pnp",
  symbol: {
    bbox: {
      max: {
        x: 100,
        y: 50,
      },
      min: {
        x: -10,
        y: -50,
      },
    },
    contentKind: "symbol",
    exprLabels: [
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-name",
        loc: {
          x: 50,
          y: -40,
        },
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 50,
          y: -28,
        },
        rotation: 0,
        spec: {
          index: 1,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 50,
          y: -16,
        },
        rotation: 0,
        spec: {
          index: 2,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 50,
          y: -4,
        },
        rotation: 0,
        spec: {
          index: 3,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 50,
          y: 8,
        },
        rotation: 0,
        spec: {
          index: 4,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 50,
          y: 20,
        },
        rotation: 0,
        spec: {
          index: 5,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 50,
          y: 32,
        },
        rotation: 0,
        spec: {
          index: 6,
          kind: "index",
        },
      },
      {
        alignment: "right",
        baseline: "middle",
        height: 8,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -2,
          y: 0,
        },
        name: "b",
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: 35,
          y: -40,
        },
        name: "e",
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "top",
        height: 8,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: 35,
          y: 40,
        },
        name: "c",
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "cell-name",
        loc: {
          x: 45,
          y: -45,
        },
        rotation: 0,
      },
    ],
    graphics: [
      {
        kind: "path",
        points: [
          {
            x: 20,
            y: -15,
          },
          {
            x: 20,
            y: 15,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 3,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: 0,
          },
          {
            x: 20,
            y: 0,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 20,
            y: -8,
          },
          {
            x: 40,
            y: -25,
          },
          {
            x: 40,
            y: -40,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 20,
            y: 8,
          },
          {
            x: 40,
            y: 25,
          },
          {
            x: 40,
            y: 40,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 36,
            y: -15,
          },
          {
            x: 27,
            y: -14,
          },
          {
            x: 30,
            y: -23,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
    ],
    ident: {
      id: "pnp",
      kind: "builtin",
    },
    pins: [
      {
        direction: "inout",
        portName: "e",
        shape: {
          bbox: {
            max: {
              x: 44,
              y: -36,
            },
            min: {
              x: 36,
              y: -44,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
      {
        direction: "inout",
        portName: "b",
        shape: {
          bbox: {
            max: {
              x: 4,
              y: 4,
            },
            min: {
              x: -4,
              y: -4,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
      {
        direction: "inout",
        portName: "c",
        shape: {
          bbox: {
            max: {
              x: 44,
              y: 44,
            },
            min: {
              x: 36,
              y: 36,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
    ],
    schemaVersion: SCHEMA_VERSION,
    selectionBoxes: [
      {
        max: {
          x: 45,
          y: 40,
        },
        min: {
          x: 0,
          y: -40,
        },
      },
    ],
  },
} satisfies BuiltinSpec<"pnp">;
export type Pnp = typeof Pnp;

export const Res = {
  id: "res",
  symbol: {
    bbox: {
      max: {
        x: 91,
        y: 17,
      },
      min: {
        x: -55,
        y: -81,
      },
    },
    contentKind: "symbol",
    exprLabels: [
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 22,
          y: -12,
        },
        rotation: 0,
        spec: {
          index: 2,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 7,
        hidden: false,
        kind: "cell-name",
        loc: {
          x: -46,
          y: 9,
        },
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: 37,
          y: -40,
        },
        name: "nwl",
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -3,
          y: -52,
        },
        name: "b",
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 22,
          y: -50,
        },
        rotation: 0,
        spec: {
          index: 4,
          kind: "index",
        },
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -3,
          y: -10,
        },
        name: "a",
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 22,
          y: -21,
        },
        rotation: 0,
        spec: {
          index: 3,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 7,
        hidden: false,
        kind: "inst-name",
        loc: {
          x: 1,
          y: 9,
        },
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 22,
          y: -3,
        },
        rotation: 0,
        spec: {
          index: 1,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 22,
          y: -59,
        },
        rotation: 0,
        spec: {
          index: 5,
          kind: "index",
        },
      },
    ],
    graphics: [
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: -60,
          },
          {
            x: 0,
            y: -48,
          },
          {
            x: 10,
            y: -45,
          },
          {
            x: -10,
            y: -39,
          },
          {
            x: 10,
            y: -33,
          },
          {
            x: -10,
            y: -27,
          },
          {
            x: 10,
            y: -21,
          },
          {
            x: -10,
            y: -15,
          },
          {
            x: 0,
            y: -12,
          },
          {
            x: 0,
            y: 0,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
    ],
    ident: {
      id: "res",
      kind: "builtin",
    },
    pins: [
      {
        direction: "inout",
        labelFmt: {
          alignment: "left",
          baseline: "bottom",
          height: 10,
          hidden: true,
          loc: {
            x: -24,
            y: 4,
          },
          rotation: 0,
        },
        portName: "a",
        shape: {
          filled: false,
          kind: "polygon",
          points: [
            {
              x: 4,
              y: 4,
            },
            {
              x: -4,
              y: 4,
            },
            {
              x: -4,
              y: -4,
            },
            {
              x: 4,
              y: -4,
            },
          ],
        },
        width: 1,
      },
      {
        direction: "inout",
        labelFmt: {
          alignment: "left",
          baseline: "bottom",
          height: 10,
          hidden: true,
          loc: {
            x: -24,
            y: -76,
          },
          rotation: 0,
        },
        portName: "b",
        shape: {
          filled: false,
          kind: "polygon",
          points: [
            {
              x: 4,
              y: -56,
            },
            {
              x: -4,
              y: -56,
            },
            {
              x: -4,
              y: -64,
            },
            {
              x: 4,
              y: -64,
            },
          ],
        },
        width: 1,
      },
    ],
    schemaVersion: SCHEMA_VERSION,
    selectionBoxes: [
      {
        max: {
          x: 20,
          y: 0,
        },
        min: {
          x: -19,
          y: -60,
        },
      },
    ],
  },
} satisfies BuiltinSpec<"res">;
export type Res = typeof Res;

export const Res3 = {
  id: "res3",
  symbol: {
    bbox: {
      max: {
        x: 91,
        y: 17,
      },
      min: {
        x: -55,
        y: -81,
      },
    },
    contentKind: "symbol",
    exprLabels: [
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 22,
          y: -12,
        },
        rotation: 0,
        spec: {
          index: 2,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 7,
        hidden: false,
        kind: "cell-name",
        loc: {
          x: -46,
          y: 9,
        },
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: 37,
          y: -40,
        },
        name: "nwl",
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -3,
          y: -52,
        },
        name: "b",
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 22,
          y: -50,
        },
        rotation: 0,
        spec: {
          index: 4,
          kind: "index",
        },
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -3,
          y: -10,
        },
        name: "a",
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 22,
          y: -21,
        },
        rotation: 0,
        spec: {
          index: 3,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 7,
        hidden: false,
        kind: "inst-name",
        loc: {
          x: 1,
          y: 9,
        },
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 22,
          y: -3,
        },
        rotation: 0,
        spec: {
          index: 1,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 22,
          y: -59,
        },
        rotation: 0,
        spec: {
          index: 5,
          kind: "index",
        },
      },
    ],
    graphics: [
      {
        kind: "path",
        points: [
          {
            x: 20,
            y: -30,
          },
          {
            x: 13,
            y: -30,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 13,
            y: -12,
          },
          {
            x: 13,
            y: -48,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: -60,
          },
          {
            x: 0,
            y: -48,
          },
          {
            x: 10,
            y: -45,
          },
          {
            x: -10,
            y: -39,
          },
          {
            x: 10,
            y: -33,
          },
          {
            x: -10,
            y: -27,
          },
          {
            x: 10,
            y: -21,
          },
          {
            x: -10,
            y: -15,
          },
          {
            x: 0,
            y: -12,
          },
          {
            x: 0,
            y: 0,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
    ],
    ident: {
      id: "res3",
      kind: "builtin",
    },
    pins: [
      {
        direction: "inout",
        labelFmt: {
          alignment: "left",
          baseline: "bottom",
          height: 10,
          hidden: true,
          loc: {
            x: -24,
            y: 4,
          },
          rotation: 0,
        },
        portName: "a",
        shape: {
          filled: false,
          kind: "polygon",
          points: [
            {
              x: 4,
              y: 4,
            },
            {
              x: -4,
              y: 4,
            },
            {
              x: -4,
              y: -4,
            },
            {
              x: 4,
              y: -4,
            },
          ],
        },
        width: 1,
      },
      {
        direction: "inout",
        labelFmt: {
          alignment: "left",
          baseline: "bottom",
          height: 10,
          hidden: true,
          loc: {
            x: -24,
            y: -76,
          },
          rotation: 0,
        },
        portName: "b",
        shape: {
          filled: false,
          kind: "polygon",
          points: [
            {
              x: 4,
              y: -56,
            },
            {
              x: -4,
              y: -56,
            },
            {
              x: -4,
              y: -64,
            },
            {
              x: 4,
              y: -64,
            },
          ],
        },
        width: 1,
      },
      {
        direction: "inout",
        labelFmt: {
          alignment: "left",
          baseline: "bottom",
          height: 10,
          hidden: true,
          loc: {
            x: 26,
            y: -36,
          },
          rotation: 0,
        },
        portName: "c",
        shape: {
          filled: false,
          kind: "polygon",
          points: [
            {
              x: 24,
              y: -26,
            },
            {
              x: 16,
              y: -26,
            },
            {
              x: 16,
              y: -34,
            },
            {
              x: 24,
              y: -34,
            },
          ],
        },
        width: 1,
      },
    ],
    schemaVersion: SCHEMA_VERSION,
    selectionBoxes: [
      {
        max: {
          x: 20,
          y: 0,
        },
        min: {
          x: -19,
          y: -60,
        },
      },
    ],
  },
} satisfies BuiltinSpec<"res3">;
export type Res3 = typeof Res3;

export const Cap = {
  defaultNamePrefix: "c",
  id: "cap",
  symbol: {
    bbox: {
      max: {
        x: 67,
        y: 11,
      },
      min: {
        x: -64,
        y: -70,
      },
    },
    contentKind: "symbol",
    exprLabels: [
      {
        alignment: "center",
        baseline: "top",
        height: 5,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -6,
          y: -54,
        },
        name: "b",
        rotation: 0,
      },
      {
        alignment: "center",
        baseline: "top",
        height: 5,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -32,
          y: -53,
        },
        name: "c",
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 17,
          y: -18,
        },
        rotation: 0,
        spec: {
          index: 2,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 17,
          y: -68,
        },
        rotation: 0,
        spec: {
          index: 6,
          kind: "index",
        },
      },
      {
        alignment: "center",
        baseline: "middle",
        height: 7,
        hidden: false,
        kind: "inst-name",
        loc: {
          x: 15,
          y: 5,
        },
        rotation: 0,
      },
      {
        alignment: "center",
        baseline: "middle",
        height: 7,
        hidden: false,
        kind: "cell-name",
        loc: {
          x: -29,
          y: 4,
        },
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 17,
          y: -8,
        },
        rotation: 0,
        spec: {
          index: 1,
          kind: "index",
        },
      },
      {
        alignment: "center",
        baseline: "top",
        height: 5,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -8,
          y: -5,
        },
        name: "a",
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 17,
          y: -48,
        },
        rotation: 0,
        spec: {
          index: 5,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 17,
          y: -38,
        },
        rotation: 0,
        spec: {
          index: 4,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 17,
          y: -28,
        },
        rotation: 0,
        spec: {
          index: 3,
          kind: "index",
        },
      },
    ],
    graphics: [
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: 0,
          },
          {
            x: 0,
            y: -26,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 10,
            y: -26,
          },
          {
            x: -10,
            y: -26,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 10,
            y: -34,
          },
          {
            x: -10,
            y: -34,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: -60,
          },
          {
            x: 0,
            y: -34,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: 0,
          },
          {
            x: 0,
            y: -26,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
    ],
    ident: {
      id: "cap",
      kind: "builtin",
    },
    pins: [
      {
        direction: "inout",
        portName: "a",
        shape: {
          bbox: {
            max: {
              x: 4,
              y: 4,
            },
            min: {
              x: -4,
              y: -4,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
      {
        direction: "inout",
        portName: "b",
        shape: {
          bbox: {
            max: {
              x: 4,
              y: -56,
            },
            min: {
              x: -4,
              y: -64,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
    ],
    schemaVersion: SCHEMA_VERSION,
    selectionBoxes: [
      {
        max: {
          x: 10,
          y: 0,
        },
        min: {
          x: -20,
          y: -60,
        },
      },
    ],
  },
} satisfies BuiltinSpec<"cap">;
export type Cap = typeof Cap;

export const Cap3 = {
  defaultNamePrefix: "c",
  id: "cap3",
  symbol: {
    bbox: {
      max: {
        x: 67,
        y: 11,
      },
      min: {
        x: -64,
        y: -70,
      },
    },
    contentKind: "symbol",
    exprLabels: [
      {
        alignment: "center",
        baseline: "top",
        height: 5,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -6,
          y: -54,
        },
        name: "b",
        rotation: 0,
      },
      {
        alignment: "center",
        baseline: "top",
        height: 5,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -32,
          y: -53,
        },
        name: "c",
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 17,
          y: -18,
        },
        rotation: 0,
        spec: {
          index: 2,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 17,
          y: -68,
        },
        rotation: 0,
        spec: {
          index: 6,
          kind: "index",
        },
      },
      {
        alignment: "center",
        baseline: "middle",
        height: 7,
        hidden: false,
        kind: "inst-name",
        loc: {
          x: 15,
          y: 5,
        },
        rotation: 0,
      },
      {
        alignment: "center",
        baseline: "middle",
        height: 7,
        hidden: false,
        kind: "cell-name",
        loc: {
          x: -29,
          y: 4,
        },
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 17,
          y: -8,
        },
        rotation: 0,
        spec: {
          index: 1,
          kind: "index",
        },
      },
      {
        alignment: "center",
        baseline: "top",
        height: 5,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -8,
          y: -5,
        },
        name: "a",
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 17,
          y: -48,
        },
        rotation: 0,
        spec: {
          index: 5,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 17,
          y: -38,
        },
        rotation: 0,
        spec: {
          index: 4,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 17,
          y: -28,
        },
        rotation: 0,
        spec: {
          index: 3,
          kind: "index",
        },
      },
    ],
    graphics: [
      {
        bbox: {
          max: {
            x: -9,
            y: -42,
          },
          min: {
            x: -11,
            y: -44,
          },
        },
        filled: false,
        kind: "ellipse",
      },
      {
        kind: "path",
        points: [
          {
            x: -20,
            y: -56,
          },
          {
            x: -20,
            y: -43,
          },
          {
            x: -11,
            y: -43,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: 0,
          },
          {
            x: 0,
            y: -26,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 10,
            y: -26,
          },
          {
            x: -10,
            y: -26,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 10,
            y: -34,
          },
          {
            x: -10,
            y: -34,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: -60,
          },
          {
            x: 0,
            y: -34,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: 0,
          },
          {
            x: 0,
            y: -26,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
    ],
    ident: {
      id: "cap3",
      kind: "builtin",
    },
    pins: [
      {
        direction: "inout",
        portName: "c",
        shape: {
          bbox: {
            max: {
              x: -16,
              y: -56,
            },
            min: {
              x: -24,
              y: -64,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
      {
        direction: "inout",
        portName: "b",
        shape: {
          bbox: {
            max: {
              x: 4,
              y: -56,
            },
            min: {
              x: -4,
              y: -64,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
      {
        direction: "inout",
        portName: "a",
        shape: {
          bbox: {
            max: {
              x: 4,
              y: 4,
            },
            min: {
              x: -4,
              y: -4,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
    ],
    schemaVersion: SCHEMA_VERSION,
    selectionBoxes: [
      {
        max: {
          x: 10,
          y: 0,
        },
        min: {
          x: -20,
          y: -60,
        },
      },
    ],
  },
} satisfies BuiltinSpec<"cap3">;
export type Cap3 = typeof Cap3;

export const Ind = {
  defaultNamePrefix: "l",
  id: "ind",
  symbol: {
    bbox: {
      max: {
        x: 94,
        y: 4,
      },
      min: {
        x: -117,
        y: -64,
      },
    },
    contentKind: "symbol",
    exprLabels: [
      {
        alignment: "right",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -5,
          y: -59,
        },
        name: "MINUS",
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -5,
          y: -10,
        },
        name: "PLUS",
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-name",
        loc: {
          x: 15,
          y: -10,
        },
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 15,
          y: -55,
        },
        rotation: 0,
        spec: {
          index: 3,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 15,
          y: -25,
        },
        rotation: 0,
        spec: {
          index: 1,
          kind: "index",
        },
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 8,
        hidden: false,
        kind: "inst-param",
        loc: {
          x: 15,
          y: -40,
        },
        rotation: 0,
        spec: {
          index: 2,
          kind: "index",
        },
      },
    ],
    graphics: [
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: 0,
          },
          {
            x: 0,
            y: -14,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: -14,
          },
          {
            x: 2,
            y: -14,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: -22,
          },
          {
            x: 2,
            y: -22,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: -30,
          },
          {
            x: 2,
            y: -30,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: -38,
          },
          {
            x: 2,
            y: -38,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: -46,
          },
          {
            x: 2,
            y: -46,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: -46,
          },
          {
            x: 0,
            y: -60,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        arcBbox: {
          max: {
            x: 7,
            y: -30,
          },
          min: {
            x: 2,
            y: -38,
          },
        },
        ellipseBbox: {
          max: {
            x: 7,
            y: -30,
          },
          min: {
            x: -1,
            y: -38,
          },
        },
        kind: "arc",
        startAngle: 4.7123889366733,
        stopAngle: 1.8234764337539673,
      },
      {
        arcBbox: {
          max: {
            x: 7,
            y: -22,
          },
          min: {
            x: 2,
            y: -30,
          },
        },
        ellipseBbox: {
          max: {
            x: 7,
            y: -22,
          },
          min: {
            x: -1,
            y: -30,
          },
        },
        kind: "arc",
        startAngle: 4.7123889366733,
        stopAngle: 1.8234764337539673,
      },
      {
        arcBbox: {
          max: {
            x: 7,
            y: -38,
          },
          min: {
            x: 2,
            y: -46,
          },
        },
        ellipseBbox: {
          max: {
            x: 7,
            y: -38,
          },
          min: {
            x: -1,
            y: -46,
          },
        },
        kind: "arc",
        startAngle: 4.7123889366733,
        stopAngle: 1.8234764337539673,
      },
      {
        arcBbox: {
          max: {
            x: 7,
            y: -14,
          },
          min: {
            x: 2,
            y: -22,
          },
        },
        ellipseBbox: {
          max: {
            x: 7,
            y: -14,
          },
          min: {
            x: -1,
            y: -22,
          },
        },
        kind: "arc",
        startAngle: 4.7123889366733,
        stopAngle: 1.8234764337539673,
      },
      {
        bbox: {
          max: {
            x: 11,
            y: -5,
          },
          min: {
            x: 5,
            y: -11,
          },
        },
        filled: false,
        kind: "ellipse",
      },
    ],
    ident: {
      id: "ind",
      kind: "builtin",
    },
    pins: [
      {
        direction: "inout",
        portName: "MINUS",
        shape: {
          bbox: {
            max: {
              x: 4,
              y: -56,
            },
            min: {
              x: -4,
              y: -64,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
      {
        direction: "inout",
        portName: "PLUS",
        shape: {
          bbox: {
            max: {
              x: 4,
              y: 4,
            },
            min: {
              x: -4,
              y: -4,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
    ],
    schemaVersion: SCHEMA_VERSION,
    selectionBoxes: [
      {
        max: {
          x: 20,
          y: 0,
        },
        min: {
          x: -20,
          y: -60,
        },
      },
    ],
  },
} satisfies BuiltinSpec<"ind">;
export type Ind = typeof Ind;

export const Ccs = {
  defaultNamePrefix: "i",
  id: "ccs",
  symbol: {
    bbox: {
      max: {
        x: 30,
        y: 40,
      },
      min: {
        x: -30,
        y: -40,
      },
    },
    contentKind: "symbol",
    exprLabels: [
      {
        alignment: "center",
        baseline: "top",
        height: 5,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -6,
          y: -8,
        },
        name: "PLUS",
        rotation: 0,
      },
      {
        alignment: "center",
        baseline: "top",
        height: 5,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -8,
          y: 48,
        },
        name: "MINUS",
        rotation: 0,
      },
      {
        alignment: "center",
        baseline: "middle",
        height: 7,
        hidden: false,
        kind: "inst-name",
        loc: {
          x: 35,
          y: 20,
        },
        rotation: 0,
      },
      {
        alignment: "center",
        baseline: "middle",
        height: 7,
        hidden: false,
        kind: "cell-name",
        loc: {
          x: -35,
          y: 20,
        },
        rotation: 0,
      },
    ],
    graphics: [
      {
        bbox: {
          max: {
            x: 20,
            y: 40,
          },
          min: {
            x: -20,
            y: 0,
          },
        },
        filled: false,
        kind: "ellipse",
      },
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: 10,
          },
          {
            x: 0,
            y: 30,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: -5,
            y: 20,
          },
          {
            x: 0,
            y: 10,
          },
          {
            x: 5,
            y: 20,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
    ],
    ident: {
      id: "ccs",
      kind: "builtin",
    },
    pins: [
      {
        direction: "inout",
        portName: "PLUS",
        shape: {
          bbox: {
            max: {
              x: 4,
              y: 4,
            },
            min: {
              x: -4,
              y: -4,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
      {
        direction: "inout",
        portName: "MINUS",
        shape: {
          bbox: {
            max: {
              x: 4,
              y: 44,
            },
            min: {
              x: -4,
              y: 36,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
    ],
    schemaVersion: SCHEMA_VERSION,
    selectionBoxes: [
      {
        max: {
          x: 20,
          y: 40,
        },
        min: {
          x: -20,
          y: 0,
        },
      },
    ],
  },
} satisfies BuiltinSpec<"ccs">;
export type Ccs = typeof Ccs;

export const Vdc = {
  defaultNamePrefix: "v",
  id: "vdc",
  symbol: {
    bbox: {
      max: {
        x: 30,
        y: 40,
      },
      min: {
        x: -30,
        y: -40,
      },
    },
    contentKind: "symbol",
    exprLabels: [
      {
        alignment: "center",
        baseline: "top",
        height: 5,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -6,
          y: -8,
        },
        name: "PLUS",
        rotation: 0,
      },
      {
        alignment: "center",
        baseline: "top",
        height: 5,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -8,
          y: 48,
        },
        name: "MINUS",
        rotation: 0,
      },
      {
        alignment: "center",
        baseline: "middle",
        height: 7,
        hidden: false,
        kind: "inst-name",
        loc: {
          x: 35,
          y: 20,
        },
        rotation: 0,
      },
      {
        alignment: "center",
        baseline: "middle",
        height: 7,
        hidden: false,
        kind: "cell-name",
        loc: {
          x: -35,
          y: 20,
        },
        rotation: 0,
      },
    ],
    graphics: [
      {
        bbox: {
          max: {
            x: 20,
            y: 40,
          },
          min: {
            x: -20,
            y: 0,
          },
        },
        filled: false,
        kind: "ellipse",
      },
      {
        kind: "path",
        points: [
          {
            x: -5,
            y: 10,
          },
          {
            x: 5,
            y: 10,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: 5,
          },
          {
            x: 0,
            y: 15,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: -5,
            y: 30,
          },
          {
            x: 5,
            y: 30,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
    ],
    ident: {
      id: "vdc",
      kind: "builtin",
    },
    pins: [
      {
        direction: "inout",
        portName: "PLUS",
        shape: {
          bbox: {
            max: {
              x: 4,
              y: 4,
            },
            min: {
              x: -4,
              y: -4,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
      {
        direction: "inout",
        portName: "MINUS",
        shape: {
          bbox: {
            max: {
              x: 4,
              y: 44,
            },
            min: {
              x: -4,
              y: 36,
            },
          },
          filled: false,
          kind: "rectangle",
        },
        width: 1,
      },
    ],
    schemaVersion: SCHEMA_VERSION,
    selectionBoxes: [
      {
        max: {
          x: 20,
          y: 40,
        },
        min: {
          x: -20,
          y: 0,
        },
      },
    ],
  },
} satisfies BuiltinSpec<"vdc">;
export type Vdc = typeof Vdc;

export const Gnd = {
  id: "gnd",
  symbol: {
    bbox: {
      max: {
        x: 20,
        y: 0,
      },
      min: {
        x: -20,
        y: -40,
      },
    },
    contentKind: "symbol",
    exprLabels: [
      {
        alignment: "left",
        baseline: "bottom",
        height: 7,
        hidden: false,
        kind: "cell-name",
        loc: {
          x: -46,
          y: 9,
        },
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -3,
          y: -10,
        },
        name: "a",
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 7,
        hidden: false,
        kind: "inst-name",
        loc: {
          x: 1,
          y: 9,
        },
        rotation: 0,
      },
    ],
    graphics: [
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: 0,
          },
          {
            x: 0,
            y: -10,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: -15,
            y: -10,
          },
          {
            x: 15,
            y: -10,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: -10,
            y: -20,
          },
          {
            x: 10,
            y: -20,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: -5,
            y: -30,
          },
          {
            x: 5,
            y: -30,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
    ],
    ident: {
      id: "gnd",
      kind: "builtin",
    },
    pins: [
      {
        direction: "inout",
        labelFmt: {
          alignment: "left",
          baseline: "bottom",
          height: 10,
          hidden: true,
          loc: {
            x: -24,
            y: 4,
          },
          rotation: 0,
        },
        portName: "a",
        shape: {
          filled: false,
          kind: "polygon",
          points: [
            {
              x: 4,
              y: 4,
            },
            {
              x: -4,
              y: 4,
            },
            {
              x: -4,
              y: -4,
            },
            {
              x: 4,
              y: -4,
            },
          ],
        },
        width: 1,
      },
    ],
    schemaVersion: SCHEMA_VERSION,
    selectionBoxes: [
      {
        max: {
          x: 20,
          y: 0,
        },
        min: {
          x: -20,
          y: -40,
        },
      },
    ],
  },
} satisfies BuiltinSpec<"gnd">;
export type Gnd = typeof Gnd;

export const Vdd = {
  id: "vdd",
  symbol: {
    bbox: {
      max: {
        x: 20,
        y: 30,
      },
      min: {
        x: -20,
        y: -10,
      },
    },
    contentKind: "symbol",
    exprLabels: [
      {
        alignment: "left",
        baseline: "bottom",
        height: 7,
        hidden: false,
        kind: "cell-name",
        loc: {
          x: -46,
          y: 39,
        },
        rotation: 0,
      },
      {
        alignment: "right",
        baseline: "bottom",
        height: 5,
        hidden: false,
        kind: "port-debug",
        loc: {
          x: -3,
          y: 20,
        },
        name: "a",
        rotation: 0,
      },
      {
        alignment: "left",
        baseline: "bottom",
        height: 7,
        hidden: false,
        kind: "inst-name",
        loc: {
          x: 1,
          y: 39,
        },
        rotation: 0,
      },
    ],
    graphics: [
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: 30,
          },
          {
            x: 0,
            y: 0,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: -15,
            y: 30,
          },
          {
            x: 15,
            y: 30,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
    ],
    ident: {
      id: "vdd",
      kind: "builtin",
    },
    pins: [
      {
        direction: "inout",
        labelFmt: {
          alignment: "left",
          baseline: "bottom",
          height: 10,
          hidden: true,
          loc: {
            x: -24,
            y: 34,
          },
          rotation: 0,
        },
        portName: "a",
        shape: {
          filled: false,
          kind: "polygon",
          points: [
            {
              x: 4,
              y: 4,
            },
            {
              x: -4,
              y: 4,
            },
            {
              x: -4,
              y: -4,
            },
            {
              x: 4,
              y: -4,
            },
          ],
        },
        width: 1,
      },
    ],
    schemaVersion: SCHEMA_VERSION,
    selectionBoxes: [
      {
        max: {
          x: 20,
          y: 30,
        },
        min: {
          x: -20,
          y: -10,
        },
      },
    ],
  },
} satisfies BuiltinSpec<"vdd">;
export type Vdd = typeof Vdd;

export const NoConnect = {
  id: "no_connect",
  symbol: {
    bbox: {
      max: {
        x: 24,
        y: 8,
      },
      min: {
        x: -4,
        y: -8,
      },
    },
    contentKind: "symbol",
    exprLabels: [],
    graphics: [
      {
        kind: "path",
        points: [
          {
            x: 0,
            y: 0,
          },
          {
            x: 10,
            y: 0,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        filled: false,
        kind: "polygon",
        points: [
          {
            x: 10,
            y: -6,
          },
          {
            x: 22,
            y: -6,
          },
          {
            x: 22,
            y: 6,
          },
          {
            x: 10,
            y: 6,
          },
        ],
      },
      {
        kind: "path",
        points: [
          {
            x: 10,
            y: -6,
          },
          {
            x: 22,
            y: 6,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
      {
        kind: "path",
        points: [
          {
            x: 10,
            y: 6,
          },
          {
            x: 22,
            y: -6,
          },
        ],
        style: {
          beginExt: 0,
          endExt: 0,
          width: 2,
        },
      },
    ],
    ident: {
      id: "no_connect",
      kind: "builtin",
    },
    pins: [
      {
        direction: "inout",
        labelFmt: {
          alignment: "left",
          baseline: "bottom",
          height: 10,
          hidden: true,
          loc: {
            x: -8,
            y: 4,
          },
          rotation: 0,
        },
        portName: "a",
        shape: {
          filled: false,
          kind: "polygon",
          points: [
            {
              x: 4,
              y: 4,
            },
            {
              x: -4,
              y: 4,
            },
            {
              x: -4,
              y: -4,
            },
            {
              x: 4,
              y: -4,
            },
          ],
        },
        width: 1,
      },
    ],
    schemaVersion: SCHEMA_VERSION,
    selectionBoxes: [
      {
        max: {
          x: 24,
          y: 8,
        },
        min: {
          x: -4,
          y: -8,
        },
      },
    ],
  },
} satisfies BuiltinSpec<"no_connect">;
export type NoConnect = typeof NoConnect;

export const allBuiltins = [
  Nmos,
  Pmos,
  Npn,
  Pnp,
  Res,
  Res3,
  Cap,
  Cap3,
  Ind,
  Ccs,
  Vdc,
  Gnd,
  Vdd,
  NoConnect,
];
